module.exports = __webpack_public_path__ + "img/img-placeholder.c05dd8ce.png";